import React from 'react'
import { withRouter } from 'react-router-dom'
import { Card, Row, Col, Button } from 'reactstrap'

const PageNotFound = props => {
  const goBack = () => {
    props.history.goBack()
  }

  return (
    <Row style={{ textAlign: 'center', paddingTop: '5vh' }}>
      <Col xs={12} sm={12} md={6} lg={5} style={{ margin: 'auto' }}>
        <Card className=" p-30">
          <h1>404</h1>
          <h6>We can’t seem to find the page you’re looking for.</h6>
          <Button
            className="button mf-primary-btn btn-lg mb-25"
            onClick={goBack}
            style={{ width: '300px', margin: 'auto', marginTop: '20px' }}
          >
            Go Back
          </Button>
        </Card>
      </Col>
    </Row>
  )
}

export default withRouter(PageNotFound)
